<template>
  <div class="v2-layout" :class="{ censored: isCensored }" @click.capture="onAppClick">
    <layout-header v-if="!loading" :menu-items="headerMenuItems" />
    <div class="layout-container">
      <slot />
    </div>
    <template v-if="!loading">
      <layout-footer :menu-items="footerMenuItems" />
      <layout-footer-copyright />
      <modal-signup />
      <modal-login />
      <modal-forgot-password />
      <modal-age-approval />
    </template>
  </div>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from "vue";
import { useLayoutStore } from "@/store/layout";
import { useI18n } from "vue-i18n";
import LayoutHeader from "@/components/v2/layout-header";
import LayoutFooter from "@/components/v2/layout-footer";
import LayoutFooterCopyright from "@/components/v2/layout-footer-copyright/index.vue";
import { useAgeVerification } from "@/utils/ageVerification.ts";
import { useRoleStore } from "@/store/role.ts";
import { ROLE_CENSORED_TOKEN } from "@/utils/variables.ts";

const ModalAgeApproval = defineAsyncComponent(() => import("@/components/v2/modals/modal-age-approval/index.vue"));
const ModalForgotPassword = defineAsyncComponent(() => import("@/components/v2/modals/modal-forgot-password/index.vue"));
const ModalSignup = defineAsyncComponent(() => import("@/components/v2/modals/modal-signup/index.vue"));
const ModalLogin = defineAsyncComponent(() => import("@/components/v2/modals/modal-login/index.vue"));

defineOptions({
  name: "v2-layout",
});

const layoutStore = useLayoutStore();
const roleStore = useRoleStore();

const { t } = useI18n();

const isCensored = computed(() => roleStore.hasRole(ROLE_CENSORED_TOKEN));

const loading = computed(() => layoutStore.getPageLoading);
const { onAppClick } = useAgeVerification(loading);

const headerMenuItems = computed(() => [
  { url: "/about_us", anchor: t("About us"), name: "about-us" },
  { url: "/#meet-ersties", anchor: t("Models"), name: "meet ersties" },
  { url: "/#videos", anchor: t("Videos"), name: "videos" },
  { url: "/#reviews", anchor: t("Reviews"), name: "reviews" },
  { url: "/#currently-on-ersties", anchor: t("News"), name: "news" },
]);

const footerMenuItems = computed(() => [
  { url: "/about_us", anchor: t("About Ersties"), name: "about-us" },
  { url: "/#meet-ersties", anchor: t("Models"), name: "meet ersties" },
  { url: "/#videos", anchor: t("Videos"), name: "videos" },
  { url: "/#reviews", anchor: t("Customer reviews"), name: "reviews" },
  { url: "/#currently-on-ersties", anchor: t("News & updates"), name: "news" },
]);
</script>

<style lang="scss">
@import "./index.scss";
@import "~@/assets/v2/css/main.scss";
</style>
